export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const NOT_ENTER_USER = 'NOT_ENTER_USER';
export const SET_USER_LOGOUT = 'SET_USER_LOGOUT';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_ID_ALERT = 'SET_ID_ALERT';
